import React, {FC, useState} from "react";
import {useLocation, useParams} from "react-router-dom";
import BlockDetailsOverview from "./block-details-overview";
import {useTranslation} from "react-i18next";
import useCommon from "../../common/hooks/useCommon";

const BlockDetails: FC = () => {
    const location = useLocation();
    const hashSplit = location.hash.split("#");
    const {block} = useParams();
    const {get0x} = useCommon();
    const {t, i18n} = useTranslation();
    const [isgetError, setIsgetError] = useState(false);
    const [tab, setTab] = useState(hashSplit?.[1] ?? "");

    const handleTab = (e: string) => {
        setTab(e);
        if (!!e?.length) window.location.hash = `#${e}`;
        else {
            window.location.hash = "";
            // @ts-ignore
            window.history.replaceState(null, null, " ");
        }
    };
    return (
        <div className="py-3">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="bs-page-title">
                            {t("Block")}
                            <span className="bs-page-title-secondary">#{block}</span>
                        </div>
                    </div>
                </div>
                {isgetError ? (
                    <div className="bs-card mb-3">
                        <div className="bs-card-body text-center py-28">
                            <div className="mb-4">
                                <span
                                    className="bg-warning bg-opacity-10 border border-warning border-opacity-25 text-yellow-600 fs-70x content-center rounded-pill mx-auto content-not-found">
                                    <i className="bi bi-file-earmark-x fs-4 text-yellow-600"></i>
                                </span>
                            </div>
                            <h2 className="page-error-title">
                                Sorry, We are unable to locate this Block
                            </h2>
                            <p className="text-muted mb-0">{get0x(block)}</p>
                        </div>
                        <div className="bs-card-footer">
                            <div className="alert alert-dark mt-3" role="alert">
                                <div className="d-flex align-items-baseline gap-2">
                                    <i className="bi bi-info-circle-fill"></i>
                                    <span>
                                        OpenScan.ai only provides an overview of the current state
                                        of the blockchain such as your block status but we
                                        have no control over these blocks
                                    </span>
                                </div>
                            </div>
                            <ol className="list-xs-space mb-0 ps-4 transaction-not-fount-ol" type="1">
                                <li>
                                    If you have just submitted a transaction please wait for at
                                    least 30 seconds before refreshing this page.
                                </li>
                                <li>
                                    It could still be in the Block Pool of a different node,
                                    waiting to be broadcasted.
                                </li>
                                <li>
                                    When the network is busy it can take a while for your
                                    block to propagate through the network and for us to
                                    index it.
                                </li>
                                <li>
                                    If it still does not show up after 1 hour, please check with
                                    your sender/exchange/wallet/transaction provider for
                                    additional information.
                                </li>
                            </ol>
                        </div>
                    </div>
                ) : (
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="bs-tab">
                                <button
                                    className={`bs-tab-item ${[""].includes(tab) ? "active" : ""}`}
                                    onClick={() => handleTab("")}
                                >
                                    {t("Overview")}
                                </button>
                                {/*<button className={`bs-tab-item ${["blockSigner"].includes(tab) ? 'active' : ''}`}*/}
                                {/*        onClick={() => handleTab("blockSigner")}>Block Signer*/}
                                {/*</button>*/}
                            </div>
                            <div className="bs-tab-content">
                                {[""].includes(tab) && <BlockDetailsOverview
                                    handleGetError={() => setIsgetError(true)}
                                />}
                                {/*{["blockSigner"].includes(tab) && <BlockSignerList hash={stats?.hash}/>}*/}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BlockDetails;
